import React from 'react';
import { Section } from './ui/Section';
import { Zap, ShieldCheck, Activity } from 'lucide-react';
export function MechanismSection() {
  return <Section data-id="element-177">
      <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-178">
        <div className="relative" data-id="element-179">
          <img src="https://images.unsplash.com/photo-1587854692152-cbe660dbde88?auto=format&fit=crop&q=80" alt="Estructura molecular del veneno de abeja" className="rounded-2xl shadow-2xl w-full" data-id="element-180" />
          <div className="absolute inset-0 bg-gradient-to-tr from-[#2D5016]/20 to-transparent rounded-2xl" data-id="element-181"></div>
        </div>

        <div data-id="element-182">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-183">
            Por qué StingFit funciona cuando todo lo demás falló
          </h2>
          <p className="text-lg text-gray-600 mb-8" data-id="element-184">
            La mayoría de soluciones solo atacan la grasa. StingFit tiene un
            enfoque dual:{' '}
            <span className="font-bold text-[#2D5016]" data-id="element-185">
              activa tu metabolismo para quemar grasa Y elimina la inflamación
            </span>
            .
          </p>

          <div className="space-y-6" data-id="element-186">
            <div className="flex gap-4" data-id="element-187">
              <div className="w-12 h-12 bg-[#D4AF37]/10 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-188">
                <Zap className="w-6 h-6 text-[#D4AF37]" data-id="element-189" />
              </div>
              <div data-id="element-190">
                <h3 className="font-bold text-gray-900 text-lg" data-id="element-191">
                  Activación Metabólica con Veneno de Abeja
                </h3>
                <p className="text-gray-600" data-id="element-192">
                  Estimula la circulación y activa el metabolismo local en la
                  zona abdominal, promoviendo la movilización de grasa
                  almacenada y el efecto termogénico.
                </p>
              </div>
            </div>

            <div className="flex gap-4" data-id="element-193">
              <div className="w-12 h-12 bg-[#D4AF37]/10 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-194">
                <Activity className="w-6 h-6 text-[#D4AF37]" data-id="element-195" />
              </div>
              <div data-id="element-196">
                <h3 className="font-bold text-gray-900 text-lg" data-id="element-197">
                  Drenaje Linfático y Reducción de Inflamación
                </h3>
                <p className="text-gray-600" data-id="element-198">
                  Ayuda a tu cuerpo a eliminar líquidos retenidos y toxinas que
                  causan esa apariencia de "barriga hinchada", revelando tu
                  verdadera silueta.
                </p>
              </div>
            </div>

            <div className="flex gap-4" data-id="element-199">
              <div className="w-12 h-12 bg-[#D4AF37]/10 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-200">
                <ShieldCheck className="w-6 h-6 text-[#D4AF37]" data-id="element-201" />
              </div>
              <div data-id="element-202">
                <h3 className="font-bold text-gray-900 text-lg" data-id="element-203">
                  Seguro y Sin Efectos Secundarios
                </h3>
                <p className="text-gray-600" data-id="element-204">
                  Ingredientes naturales que trabajan con tu cuerpo, no contra
                  él. Acción dual: quema grasa y reduce inflamación de forma
                  natural.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}